import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
/** @deprecated 用 GlobalData */
export const useGlobalStore = create()(subscribeWithSelector(_ => ({
  isInChina: true,
  canAccessInternetViaVPN: false
})));